/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Footer_Link_Service_AgreementInputs */

const tr_legal_footer_link_service_agreement = /** @type {(inputs: Legal_Footer_Link_Service_AgreementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servis Sözleşmesi`)
};

const en_legal_footer_link_service_agreement = /** @type {(inputs: Legal_Footer_Link_Service_AgreementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service Agreement`)
};

const de_legal_footer_link_service_agreement = /** @type {(inputs: Legal_Footer_Link_Service_AgreementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicevertrag`)
};

const ru_legal_footer_link_service_agreement = /** @type {(inputs: Legal_Footer_Link_Service_AgreementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сервисный договор`)
};

/**
* | output |
* | --- |
* | "Service Agreement" |
*
* @param {Legal_Footer_Link_Service_AgreementInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_link_service_agreement = /** @type {((inputs?: Legal_Footer_Link_Service_AgreementInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Link_Service_AgreementInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_link_service_agreement(inputs)
	if (locale === "de") return de_legal_footer_link_service_agreement(inputs)
	if (locale === "ru") return ru_legal_footer_link_service_agreement(inputs)
	return tr_legal_footer_link_service_agreement(inputs)
});